import s from './Spinner.module.css'

type Props = {
  inline?: boolean
}

export const Spinner = ({ inline = false }: Props) => {
  return (
    <div className={inline ? s.inline : s.container}>
      <div className={s.spinner}>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
        <div className={s.blade}></div>
      </div>
    </div>
  )
}
